<template>
  <v-dialog
    v-model="dialog"
    overlay
    persistent
    max-width="400px"
    transition="dialog-transition"
  >
    <template #activator="{attrs}">
      <v-btn
        :loading="searching"
        @click="OpenPayment"
        v-bind="attrs"
        block
        color="info"
        >CLEAR BALANCE
        <v-icon right>fas fa-funnel-dollar</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title primary-title>
        <div class="row">
          <div class="col text-truncate">
            <strong class="blue--text">{{ expenseInfo.expense }}</strong> :
            {{ expenseInfo.expensName }}
          </div>
          <div class="col-2">
            <v-btn icon @click="close">
              <v-icon>fas fa-times</v-icon>
            </v-btn>
          </div>
        </div>
      </v-card-title>

      <v-card-text class="">
        <p class="grey lighten-3">
          <cashDisplay
            small
            :isloading="loading"
            :Balance="ExpBalance"
          ></cashDisplay>
        </p>

        <v-form v-model="valid" ref="paymentForm">
          <BaseDate
            v-model="PayDate"
            outlined
            :rules="v => !!v || 'Date is required'"
          >
          </BaseDate>
          <BaseNumInput
            :hint="
              expenseInfo.expense +
                ': ' +
                expenseInfo.Amount.toLocaleString() +
                '/Month'
            "
            :rules="[paymentRule]"
            outlined
            v-model.trim="Amount"
            label="Amount"
          ></BaseNumInput>
          <v-text-field
            name="InfoFildName"
            label="Info"
            id="InfoFildid"
            outlined
            v-model.trim="Details"
            :rules="[v => !!v || 'Provide Infomation']"
          ></v-text-field>

          <!-- <p>{{ Amount }}</p> -->
          <!-- <p>{{ expenseInfo }}</p> -->
        </v-form>
        <p v-if="ErrMsg" v-html="ErrMsg" class="text-center error--text"></p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          width="200px"
          :loading="loading"
          @click="OnSavePayment"
          :disabled="!valid"
          color="success"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
// import { mapGetters } from "vuex";
import cashDisplay from "@/components/coman/cashViewNoRow.vue";
export default {
  components: { cashDisplay },
  props: {
    expenseInfo: { type: Object, required: true },
    ExpBalance: { type: Array, required: true },
    Onfinsh: { type: Function, required: true },
  },
  data() {
    return {
      BaseURL: "/expense/fixed/Clearpayment",
      ErrMsg: "",
      loading: false,
      searching: false,
      dialog: false,
      valid: false,
      PayDate: "",
      Amount: 0,
      Details: "",
    };
  },
  watch: {
    dialog(v) {
      if (v) {
        this.$nextTick(() => {
          this.PayDate = this.Current().date;
          // this.Amount = this.DueAmount;
          //   this.Amount = 0;
        });
      }
    },
  },

  methods: {
    close() {
      this.dialog = false;
      this.ErrMsg = "";
      this.PayDate = "";
      this.Details = "";
      this.Amount = 0;
      this.$refs.paymentForm.resetValidation();
    },

    OpenPayment() {
      this.dialog = true;
    },
    OnSavePayment() {
      this.ErrMsg = "";
      if (this.$refs.paymentForm.validate()) {
        let data = {
          Description: this.expenseInfo._id,
          Amount: this.Amount,
          Details: this.Details,
          date: this.PayDate,
          time: this.Current().time,
        };
        this.loading = true;
        this.$store
          .dispatch("INSERT_ONLY", { url: this.BaseURL, data })
          .then(() => {
            // console.log(val);
            this.loading = false;
            this.Onfinsh();
            this.close();
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
            this.ErrMsg = error && error.response && error.response.data;
          });
      }
    },
    paymentRule(v) {
      //   v = v.replace(/,/g, "");
      if (Number(v.trim()) == 0) return "0 is not allowed";

      return !!v || "Amount is required";
    },
  },
};
</script>
